
export default function(state=null,action){
    switch (action.type) {
      case "GET_UPDATE_STATUS_ACTION":
          return action.payload;
          
      default: return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/reducer/get_update_status.js